import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import ButtonModule from '../../libs/component-lib/components/button/button-module';
import CardBodyModule from '../../libs/component-lib/components/card-body/card-body.module';
import CardHeaderModule from '../../libs/component-lib/components/card-header/card-header.module';
import CardModule from '../../libs/component-lib/components/card/card.module';
import MediaObjectModule from '../../libs/component-lib/components/media-object/media-object.module';
import { EvsbThankYouOutboundCardsComponent } from './evsb-thank-you-outbound-cards.component';
import { EvsbThankYouOutboundStationsComponent } from './evsb-thank-you-outbound-stations.component';
import { EvsbThankYouOutboundMapper } from './evsb-thank-you-outbound.mapper';
import { EvsbThankYouOutboundService } from './evsb-thank-you-outbound.service';

@NgModule({
  declarations: [EvsbThankYouOutboundCardsComponent, EvsbThankYouOutboundStationsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    CardBodyModule,
    CardHeaderModule,
    MediaObjectModule,
    AngularSvgIconModule,
    ButtonModule,
  ],
  exports: [EvsbThankYouOutboundCardsComponent, EvsbThankYouOutboundStationsComponent],
  providers: [EvsbThankYouOutboundService, EvsbThankYouOutboundMapper],
})
export class EvsbThankYouOutboundModule {}
